<h3 mat-dialog-title>Kayıdı silmek uzeresiniz</h3>
<div mat-dialog-content>
    <p>Emin misiniz?</p>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="deleteEmployeeIdari(data)">Evet</button>
    <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Kapat</button>
</div>